import { render, staticRenderFns } from "./HospitalizacionView.vue?vue&type=template&id=57ce5394"
import script from "./HospitalizacionView.vue?vue&type=script&lang=js"
export * from "./HospitalizacionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports